import styled from 'styled-components';
import { style } from '../../../style';

export const CourseTrailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px;
  box-shadow: 1px 0 2px 0 rgba(0, 0, 0, 0.1);
  max-width: 460px;
  width: 100%;

  font-family: 'Rubik';
`;

export const CourseInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 10px;

  height: 100%;
  width: 100%;
`;

export const CourseTitle = styled.span`
  font-size: 16px;
  font-weight: 600;

  max-width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModulesCount = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #2e63fb;
`;

export const CourseAvailableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px;
  width: 100%;
`;

export const CourseAvailableList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 16px;
`;

export const CourseCard = styled.div`
  max-width: 320px;
  width: 100%;
  height: 250px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  font-family: 'Rubik', sans-serif;
  background-color: #ffffff;
  overflow: hidden;

  opacity: ${(props) => (props.isAllowed ? 1 : 0.4)};
  cursor: ${(props) => (props.isAllowed ? 'pointer' : 'not-allowed')};

  :hover {
    box-shadow: 0 24px 48px 0 rgba(0, 0, 0, 0.14),
      0 20px 40px 0 rgba(0, 0, 0, 0.1);
  }
`;

export const ImageWrapper = styled.div`
  position: relative;

  height: 180px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const AddButton = styled.div`
  /* position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  color: #000;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center; */
  width: 50px;
  z-index: 20;
  /* margin-bottom: -30px;
  margin-left: 5px, 50px; */
  border-radius: 0px 16px 0px 4px;
  background-color: #ffffff;
  padding: 5px;
  position: absolute;
  top: 0;
  right: 0;
  /* cursor: pointer; */
  height: 30px;
  display: flex;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  cursor: ${(props) => (props.isAllowed === false ? 'not-allowed' : 'pointer')};

  img {
    width: 14px;
  }
`;

// style={{
//
//   background: '#F4F5F9',
//   borderRadius: '10px',
//   padding: '10px',
//   marginBottom: '8px'
// }}

export const DeleteButton = styled.div`
  /* background-color: white; */
  width: 50px;
  z-index: 20;
  /* margin-bottom: -30px;
  margin-left: 5px, 50px; */
  border-radius: 10px 0px 10px 0px;
  background-color: #ffffff;
  padding: 5px;
  position: absolute;
  top: 0;
  cursor: pointer;
  height: 30px;
  display: flex;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  img {
    width: 16px;
  }
`;

export const AvailableCourseInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 10px 16px;
`;

export const AvailableCourseTitle = styled.span`
  font-size: 16px;
  font-weight: 600;

  max-width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AvailableModulesCount = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #2e63fb;
`;
